import * as React from 'react';
import Box from '@mui/joy/Box';
import ListDivider from '@mui/joy/ListDivider';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import CircleIcon from '@mui/icons-material/Circle';
import AvatarWithStatus from './AvatarWithStatus';
import { toggleMessagesPane } from './utils';

export default function ChatListItem(props) {
  const {
    user_id,
    sender,
    selectedChatId,
    setSelectedChat,
    user_profile,
    setSelectedChatId,
  } = props;
  const selected = selectedChatId === user_id;
  return (
    <React.Fragment>
      <ListItem>
        <ListItemButton
          onClick={() => {
            toggleMessagesPane();
            setSelectedChat({ user_id, user_profile });
            setSelectedChatId(user_id);
          }}
          selected={selected}
          color="neutral"
          sx={{ flexDirection: 'column', alignItems: 'initial', gap: 1 }}>
          <Stack direction="row" spacing={1.5}>
            <AvatarWithStatus online={sender?.online} src={sender?.avatar} />
            <Box sx={{ flex: 1 }}>
              <Typography level="title-sm">{props.user_profile}</Typography>
              <Typography level="body-sm">+{props.user_id}</Typography>
            </Box>

            <Box sx={{ lineHeight: 1.5, textAlign: 'right' }}>
              {!props.read && (
                <CircleIcon sx={{ fontSize: 12 }} color="primary" />
              )}
              <Typography
                level="body-xs"
                noWrap
                sx={{ display: { xs: 'none', md: 'block' } }}>
                {props.creation_time}
              </Typography>
            </Box>
          </Stack>
          <Typography
            level="body-sm"
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: '2',
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
            {props.message}
          </Typography>
        </ListItemButton>
      </ListItem>
      <ListDivider sx={{ margin: 0 }} />
    </React.Fragment>
  );
}
